import React from "react";
import ReactDOM from "react-dom";


class FormError extends React.Component {
  constructor(props) {
    super(props);
  }

 
  render() {
    if(this.props.error_message)
    {
        return (
          <div className="alert alert-sm alert-danger">
            {this.props.error_message}
          </div>
        );
    }
    return null;
    
  }
}

export default FormError;
